<template>
  <div style="padding: 20px">
    <select-area @areaListId="getAreaListId"/>
    <el-select
        v-model="query.searchType"
        placeholder="校区类型"
        class="handle-select mr10"
    >
      <el-option label="所属校区" :value="1"></el-option>
      <el-option label="上课校区" :value="2"></el-option>
    </el-select>
    <el-input
        v-model="query.studentInfo"
        placeholder="学员姓名"
        style="width: 200px;margin-left: 10px"
        class="mr10"
    ></el-input>
    <el-date-picker
        style="width: 260px;margin-left: 10px"
        v-model="createdDate"
        type="daterange"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        range-separator="至"
        start-placeholder="创建日期"
        end-placeholder="创建日期"
    >
    </el-date-picker>
    <el-button
        type="primary"
        icon="Search"
        style="margin-left: 10px"
        @click="userReturn">搜索
    </el-button>
    <el-button v-permission="['userReturn:export']"
        type="primary"
        icon="Search"
        style="margin-left: 10px"
        @click="userReturnExcel">导出
    </el-button>

    <el-table
        :data="tableData"
        border
        v-loading="tableLoading"
        :row-style="{height:10+'px'}"
        :cell-style="{padding:14+'px'}"
        class="table"
        style="margin-top: 40px"
        ref="multipleTable"
        height="606px"
        header-cell-class-name="table-header"
    >
      <el-table-column align="center" width="120" show-overflow-tooltip="true" prop="studentName" label="学员姓名"/>
      <el-table-column align="center" width="140" show-overflow-tooltip="true" prop="studentPhone" label="学员电话"/>
      <el-table-column align="center" width="120" show-overflow-tooltip="true" prop="dictType" label="退费原因"/>
      <el-table-column align="center" width="200" show-overflow-tooltip="true" prop="details" label="退费说明"/>

      <el-table-column align="center" width="90" show-overflow-tooltip="true" prop="coachName" label="收款教练"/>
      <el-table-column align="center" width="140" show-overflow-tooltip="true" prop="serveCoachName" label="服务老师"/>
      <el-table-column align="center" width="110" show-overflow-tooltip="true" prop="campusName" label="所属校区"/>
      <el-table-column align="center" width="140" show-overflow-tooltip="true" prop="state" label="状态"/>
      <el-table-column align="center" width="180" show-overflow-tooltip="true" prop="submitAreaName" label="所属城市"/>
      <el-table-column align="center" width="180" show-overflow-tooltip="true" prop="submitCampusName" label="提交校区"/>
      <el-table-column align="center"  show-overflow-tooltip="true" prop="createTime" label="创建时间"/>
    </el-table>
    <div class="pagination">
      <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import SelectArea from "../../../components/SelectArea";
import { userReturn,userReturnExcel } from "@/api/refundOrTurnRecord"
export default {
  name: "UserReturn",
  components:{
    SelectArea,
  },
  created() {
    this.userReturn();
  },
  data() {
    return {
      createdDate:null,
      tableData:[],
      pageTotal:0,
      query:{
        pageIndex: 1,
        pageSize: 10,
        studentInfo:"",
        areaList:[],
        startTime:null,
        endTime:null,
        searchType:1
      }
    }
  },
  methods:{
    handlePageChange(index){
      this.query.pageIndex = index;
      this.userReturn();
    },
    userReturnExcel(){
      if (this.createdDate){
        this.query.startTime = this.createdDate[0];
        this.query.endTime = this.createdDate[1];
      }else {
        this.query.startTime = null;
        this.query.endTime = null;
      }
      userReturnExcel(this.query)
      this.$message.success('正在导出请稍等，右上角查看！');
    },
    userReturn(){
      if (this.createdDate){
        this.query.startTime = this.createdDate[0];
        this.query.endTime = this.createdDate[1];
      }else {
        this.query.startTime = null;
        this.query.endTime = null;
      }
      userReturn(this.query).then(val=>{
        this.tableData = val.data.records;
        this.pageTotal = val.data.total;
      })
    },

    //点选选择某个区域
    getAreaListId(val) {
      this.query.areaList = val;
    },
  }
}
</script>

<style scoped>

</style>